import { memo } from 'react';

import styled from 'styled-components';

import {
  LanguageSwitcherMenu,
  LanguageSwitcherMenuProps,
} from '@components/language-switcher-menu';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type CompanyHeaderProps = {
  url: string;
  logo: string | null;
  logoHeight: number;
  enabledLanguages: LanguageSwitcherMenuProps['enabled'];
};

export const CompanyHeader = memo<CompanyHeaderProps>(
  ({ logo, url, logoHeight, enabledLanguages }) => {
    return (
      <Top $logoHeight={logoHeight}>
        <div>
          <div>
            <a href={url} rel="noopener noreferrer">
              {logo && <img id="company-logo" src={logo} alt="logo" />}
            </a>
          </div>
          <LanguageSwitcherMenu enabled={enabledLanguages} />
        </div>
      </Top>
    );
  }
);

const Top = styled.div<{ $logoHeight: number }>((p) => ({
  height: pxToRem(64),
  backgroundColor: theme.color.white100,
  width: '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '> div': {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '95%',
    maxWidth: pxToRem(1180),
  },

  '#company-logo': {
    maxHeight: p.$logoHeight,
  },
}));
